export default __webpack_public_path__ + "static/PMG_EGIB_MYRUMAH_PDS_AGENCY_BM-d13a184c0c12e0496593a61fc50289e8.pdf";